var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1a.635.635 0 01-.16.425l-5.454 6a.513.513 0 01-.772 0l-5.455-6a.645.645 0 010-.85.513.513 0 01.772 0L6 6.151 11.068.575a.513.513 0 01.773 0C11.946.693 12 .846 12 1z",
    fill: "#02BD9C"
  })));
}
SvgGreenArrow.displayName = 'GreenArrow';
export default SvgGreenArrow;